import { FC } from 'react';
import { SvgIconComponent } from '@mui/icons-material';
import styles from './footer.module.css';
import { LinkList, LinkListProps } from '../../components/link-list/link-list';
import {
  SocialMidia,
  IMidia,
} from '../../components/social-midia/social-midia';

export interface FooterProps {
  lists: LinkListProps[];
  social: IMidia[];
  contacts: { Icon: SvgIconComponent; text: string }[];
  handleLinkClick: (
    e: React.MouseEvent<HTMLAnchorElement>,
    link: string,
    isExternal?: boolean
  ) => void;
}

export const Footer: FC<FooterProps> = ({
  lists,
  social,
  contacts,
  handleLinkClick,
}) => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerContent}>
          <div className={styles.topSection}>
            <div className={styles.linksContainer}>
              {lists?.map(({ title, Icon, linkList }, index) => (
                <LinkList
                  title={title}
                  Icon={Icon}
                  linkList={linkList}
                  key={index}
                  handleLinkClick={handleLinkClick}
                />
              ))}
            </div>

            <div className={styles.rightSection}>
              <img
                src={`${process.env.PUBLIC_URL}/images/logo-white-es.png`}
                alt="Logo do Governo do Espírito Santo"
                className={styles.logo}
              />
              <SocialMidia midiasList={social} />
            </div>
          </div>

          <div className={styles.separator} />

          <div className={styles.contactList}>
            {contacts.map(({ Icon, text }, index) => (
              <div className={styles.contactItem} key={index}>
                <div className={styles.contactIcon}>
                  <Icon />
                </div>
                <span className={styles.contactText}>{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
